import { useEffect, useState } from 'react';
import { fetchList } from '@/lib/api';
import { PageHero } from '@/components/Cards';
import { RosterBlock } from '@/components/Roster';
import { useContent } from '@/lib/useContent';

export default function Artists() {
  const content = useContent();
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchList('/artists').then((d) => { setArtists(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHero overline={content.artists_overline || 'The Roster'} title={content.artists_title || 'Artists'} />

      <section data-testid="artists-page" className="mx-auto max-w-[1200px] px-5 py-16 md:px-10 md:py-20">
        {loading ? (
          <p className="meta-label text-brayo-dim">Loading…</p>
        ) : (
          <RosterBlock artists={artists} />
        )}
      </section>
    </>
  );
}